import React, { useState, useRef } from "react";
import "../assets/css/preguntas.css";
import pregunta from "../assets/svg/Pregunta.svg";
import flecha from "../assets/svg/Flecha.svg";

const faqData = [
  {
    question: "¿Qué tipo de servicios legales ofrecen?",
    answer:
      "Ofrecemos asesoramiento, representación y defensa en áreas como derecho empresarial, civil, familiar, laboral y penal, adaptándonos a las necesidades específicas de nuestros clientes.",
  },
  {
    question: "¿Atienden a empresas y personas naturales?",
    answer:
      "Sí, trabajamos tanto con personas naturales como con empresas, nacionales e internacionales.",
  },
  {
    question: "¿Cómo agendo una consulta?",
    answer:
      "Puedes agendar una consulta a través de nuestro formulario en línea, llamándonos o enviando un mensaje por WhatsApp.",
  },
  {
    question: "¿Qué documentos necesito para una primera consulta?",
    answer:
      "Esto depende de tu caso. Por lo general, recomendamos traer documentos relacionados, como contratos, acuerdos o notificaciones legales.",
  },
  {
    question: "¿Cómo garantizan la confidencialidad?",
    answer:
      "Todas las consultas y casos son manejados con estricta confidencialidad, siguiendo los más altos estándares éticos y legales.",
  },
  {
    question:
      "¿Qué sucede si no puedo pagar todos los honorarios de inmediato?",
    answer:
      "Evaluamos opciones de pago flexibles según el caso y las necesidades del cliente.",
  },
  {
    question: "¿En qué idiomas brindan atención?",
    answer: "Ofrecemos atención en español e inglés, según sea necesario.",
  },
];

const Preguntas = () => {
  const [activeIndexes, setActiveIndexes] = useState([]);
  const answerRefs = useRef([]);

  const toggleFaq = (index) => {
    setActiveIndexes((prevIndexes) =>
      prevIndexes.includes(index)
        ? prevIndexes.filter((i) => i !== index)
        : [...prevIndexes, index]
    );
  };

  return (
    <section className="preguntas">
      <div className="title-preguntas">
        <h2>PREGUNTAS FRECUENTES</h2>
        <p>
          Resolvemos tus dudas más comunes para que tomes decisiones informadas
        </p>
      </div>
      <div className="preguntas-deplegables">
        {faqData.map((item, index) => (
          <div
            className={`faq-item ${activeIndexes.includes(index) ? "active" : ""}`}
            key={index}
          >
            <div className="faq-header" onClick={() => toggleFaq(index)}>
              <div className="icon-question">
                <img
                  src={pregunta}
                  alt="icono de pregunta"
                  className="icon-pregunta"
                />
              </div>
              <div className="faq-question">
                <span>{item.question}</span>
              </div>
              <span className="faq-arrow">
                <img
                  src={flecha}
                  alt="flecha desplegable"
                  className={activeIndexes.includes(index) ? "rotated" : ""}
                />
              </span>
            </div>
            <div
              className="faq-answer"
              ref={(el) => (answerRefs.current[index] = el)}
              style={{
                maxHeight: activeIndexes.includes(index)
                  ? `${answerRefs.current[index]?.scrollHeight}px`
                  : "0px",
                transition: "max-height 500ms ease-in-out, padding 500ms ease-in-out",
              }}
            >
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Preguntas;
